import DataGouvAdapter from './addresses/adapters/DataGouvAdapter'
import DrupalAdapter from './menus/adapters/DrupalAdapter'

export default {
    drupalVendor: DrupalAdapter,
    dataGouvVendor: DataGouvAdapter
}
